import { createSlice } from '@reduxjs/toolkit'

export const chooseWeekSlice = createSlice({
  name: 'chooseWeek',
  initialState: {
    value: {}
  },
  reducers: {
    setWeek: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setWeek } = chooseWeekSlice.actions

export default chooseWeekSlice.reducer